import { Form } from 'components/organisms';
import { LicenseInitialValues } from 'components/organisms/forms/settings/LicenseSettingsForm';
import { useGetLicenceConfiguration } from 'services/settings/individual';
import { formatDateToInput } from 'utils/global/date.utils';

const License = () => {
  const getLicenceConfiguration = useGetLicenceConfiguration();

  const formatLicenseData = (data: typeof getLicenceConfiguration.data) => {
    if (!data) return null;

    return {
      ...data,
      availableFrom: formatDateToInput(data.availableFrom, true),
      availableTo: formatDateToInput(data.availableTo, true),
    };
  };

  return (
    <Form.LicenseSettings
      status={{
        isLoading: getLicenceConfiguration.isLoading,
        displayMode: true,
      }}
      initialValues={
        getLicenceConfiguration.data
          ? {
              ...LicenseInitialValues,
              ...formatLicenseData(getLicenceConfiguration.data),
            }
          : LicenseInitialValues
      }
      i18nextPrefix='settings'
      onSubmit={() => {}}
    />
  );
};

export default License;
